export default "__VITE_ASSET__KIIMdK6P__"